import { handleActions } from 'redux-actions';

import { types, inputFieldNames } from '../constants';
import moment from 'moment';

import { getUniqueArray } from './../utils/attachmentUtils';
import { COURSE_NOTES } from './../constants/inputFieldNames';

const INITIAL_STATE = {
  newCourse: {
    showCreateCourseDialog: false,
    showEditCoursePanel: false,
    showEditCourseDialog: false,
    item: {},
    isSaving: false,
    errorMessage: ''
  },
  course: {
    item: null,
    isLoading: false,
    errorMessage: ''
  },
  newRecord: {
    item: {
      recordDate: null,
      notes: '',
      personnelId: null,
      attachmentFiles: [],
      existingAttachmentFiles: []
    },
    isSaving: false,
    errorMessage: '',
    openAddCourseRecordDialog: false,
    dialogOpenRequestSource: null
  },
  recordsForTheCourse: {
    items: [],
    isLoading: false,
    errorMessage: null
  },
  deleteRecord: {
    result: false,
    isSaving: false,
    errorMessage: null
  },
  editRecord: {
    enable: false,
    item: { attachmentFiles: [], existingAttachmentFiles: [] },
    isSaving: false,
    errorMessage: ''
  }
};

const openCreateCourseDialog = (state, { open }) => {
  return {
    ...state,
    newCourse: {
      ...state.newCourse,
      showCreateCourseDialog: open,
      item: {}
    }
  };
};

const openEditCoursePanel = (state, { open }) => {
  return {
    ...state,
    newCourse: {
      ...state.newCourse,
      showEditCoursePanel: open,
      item: {}
    }
  };
};

const openEditCourseDialog = (state, { open }) => {
  return {
    ...state,
    newCourse: {
      ...state.newCourse,
      showEditCourseDialog: open,
      item: {}
    }
  };
};

const courseDocumentSelected = (state, { documentLink }) => {
  const course = { ...state.newCourse.item };
  course.document = documentLink;

  return {
    ...state,
    newCourse: {
      ...state.newCourse,
      item: course
    }
  };
};

const inputChangeCreateCourseForm = (state, { value, inputfieldName }) => {
  const course = { ...state.newCourse.item };
  const record = { ...state.newRecord.item };

  switch (inputfieldName) {
    case inputFieldNames.UNIT_DESCRIPTION:
      course.unitDescription = value;
      break;
    case inputFieldNames.TRAINING_PROVIDER:
      course.trainingProvider = value;
      break;
    case inputFieldNames.COURSE_COST:
      course.courseCost = Number(value);
      break;
    case inputFieldNames.FREQUENCY_FOR_COURSE:
      course.frequency = Number(value);
      break;
    case inputFieldNames.COURSE_CATEGORY:
      course.courseCategoryId = value;
      break;
    case inputFieldNames.RECORD_DATE:
      var newDate = moment(value).local().format('YYYY-MM-DD');
      record.recordDate = newDate;
      break;
    case inputFieldNames.RECORD_NOTES:
      record.notes = value;
      break;
      case inputFieldNames.COURSE_NOTES:
        course.notes = value;
        break;
    case inputFieldNames.PERSONNEL_ID:
      record.personnelId = value;
      break;
    case inputFieldNames.COURSE:
      record.courseId = value;
      break;
    case inputFieldNames.COURSE_DOCUMENT:
      course.document = value;
      break;
    case inputFieldNames.COURSE_RECORD_ATTACHMENT:
      if (!record.attachmentFiles) {
        record.attachmentFiles = [];
      }
      record.attachmentFiles.push(value);
      var filteredArray = getUniqueArray(record.attachmentFiles);
      record.attachmentFiles = filteredArray;
      break;
    default:
  }

  return {
    ...state,
    newCourse: {
      ...state.newCourse,
      item: course
    },
    newRecord: {
      ...state.newRecord,
      item: record
    }
  };
};

const uniqueArray = (mixedArray) => {
  let newArray = [];
  let uniqueObject = {};
  for (let i in mixedArray) {
    let objTitle = mixedArray[i]['name'];
    uniqueObject[objTitle] = mixedArray[i];
  }
  for (let i in uniqueObject) {
    newArray.push(uniqueObject[i]);
  }
  return newArray;
};

const startSubmitCourse = (state) => {
  return {
    ...state,
    newCourse: {
      ...state.newCourse,
      isSaving: true
    }
  };
};

const submitCourseSuccess = (state, { submittedCourse }) => {
  return {
    ...state,
    course: {
      ...state.course,
      item: submittedCourse
    }
  };
};

const submitCourseFailure = (state, { errorMessage }) => {
  return {
    ...state,
    newCourse: {
      ...state.newCourse,
      errorMessage
    }
  };
};

const submitCourseFinished = (state) => {
  return {
    ...state,
    newCourse: {
      ...state.newCourse,
      isSaving: false
    }
  };
};

const editCourse = (state, { course }) => {
  return {
    ...state,
    newCourse: {
      ...state.newCourse,
      item: course
    }
  };
};

const startSubmitCourseRecord = (state) => {
  return {
    ...state,
    newRecord: {
      ...state.newRecord,
      isSaving: true
    }
  };
};

const submitCourseRecordSuccess = (state) => {
  return {
    ...state,
    newRecord: {
      ...state.newRecord,
      item: {
        recordDate: null,
        notes: '',
        personnelId: null
      }
    }
  };
};

const submitCourseRecordFailure = (state, { errorMessage }) => {
  return {
    ...state,
    newRecord: {
      ...state.newRecord,
      errorMessage
    }
  };
};

const submitCourseRecordFinished = (state) => {
  return {
    ...state,
    newRecord: {
      ...state.newRecord,
      isSaving: false
    }
  };
};

const startFetchRecordsForTheCourse = (state) => {
  return {
    ...state,
    recordsForTheCourse: {
      ...state.recordsForTheCourse,
      isLoading: true
    }
  };
};

const fetchRecordsForTheCourseSuccess = (state, { records }) => {
  return {
    ...state,
    recordsForTheCourse: {
      ...state.recordsForTheCourse,
      items: records
    }
  };
};

const fetchRecordsForTheCourseFailure = (state, { errorMessage }) => {
  return {
    ...state,
    recordsForTheCourse: {
      ...state.recordsForTheCourse,
      errorMessage
    }
  };
};

const fetchRecordsForTheCourseFinished = (state) => {
  return {
    ...state,
    recordsForTheCourse: {
      ...state.recordsForTheCourse,
      isLoading: false
    }
  };
};

const startDeleteCourseRecord = (state) => {
  return {
    ...state,
    deleteRecord: {
      ...state.deleteRecord,
      isSaving: true
    }
  };
};

const deleteCourseRecordSuccess = (state, { recordId }) => {
  let records = [...state.recordsForTheCourse.items];
  let deleteIndex = records.findIndex((r) => r.id === recordId);

  if (deleteIndex !== -1) {
    records.splice(deleteIndex, 1);
  }

  return {
    ...state,
    deleteRecord: {
      ...state.deleteRecord
    },
    recordsForTheCourse: {
      ...state.recordsForTheCourse,
      items: records
    }
  };
};

const deleteCourseRecordFailure = (state, { errorMessage }) => {
  return {
    ...state,
    deleteRecord: {
      ...state.deleteRecord,
      errorMessage
    }
  };
};

const deleteCourseRecordFinished = (state) => {
  return {
    ...state,
    deleteRecord: {
      ...state.deleteRecord,
      isSaving: false
    }
  };
};

const enableEditCourseRecord = (state, { enableEditRecordMode, recordId }) => {
  let record;
  if (recordId) {
    record = state.recordsForTheCourse.items.filter(
      (r) => r.id === recordId
    )[0];
  }

  return {
    ...state,
    editRecord: {
      ...state.editRecord,
      enable: enableEditRecordMode,
      item: record
    }
  };
};

const inputChangeEditCourseRecord = (state, { value, inputfieldName }) => {
  const record = { ...state.editRecord.item };

  switch (inputfieldName) {
    case inputFieldNames.PERSONNEL_ID:
      record.personnelId = value;
      break;
    case inputFieldNames.RECORD_DATE:
      var newDate = moment(value).local().format('YYYY-MM-DD');
      record.recordDate = newDate;
      break;
    case inputFieldNames.RECORD_NOTES:
      record.notes = value;
      break;
    case inputFieldNames.COURSE_RECORD_ATTACHMENT:
      if (!record.attachmentFiles) {
        record.attachmentFiles = [];
      }
      record.attachmentFiles.push(value);
      var filteredArray = uniqueArray(record.attachmentFiles);
      record.attachmentFiles = filteredArray;
      break;
    default:
  }
  return {
    ...state,
    editRecord: {
      ...state.editRecord,
      item: record
    }
  };
};

const openAddCourseRecordDialog = (state, { open, personnelId, source }) => {
  return {
    ...state,
    newRecord: {
      ...state.newRecord,
      openAddCourseRecordDialog: open,
      dialogOpenRequestSource: source,
      item: {
        ...state.newRecord.item,
        personnelId: personnelId || null
      }
    }
  };
};

const startLoadAttachmentsForCourseRecord = (state) => {
  return {
    ...state,
    editRecord: {
      ...state.editRecord,
      isSaving: true
    }
  };
};

const loadAttachmentsForCourseRecordSuccess = (state, { attachments }) => {
  var attachmentCustomObjets = [];

  for (let index = 0; index < attachments.length; index++) {
    const element = {
      id: attachments[index].id,
      newlyAdded: false,
      removed: false,
      fileData: null,
      name: attachments[index].fileName,
      url: attachments[index].url
    };
    attachmentCustomObjets.push(element);
  }

  return {
    ...state,
    editRecord: {
      ...state.editRecord,
      item: {
        ...state.editRecord.item,
        attachmentFiles: attachmentCustomObjets,
        existingAttachmentFiles: attachmentCustomObjets
      }
    }
  };
};

const loadAttachmentForCourseRecordFailure = (state, { errorMessage }) => {
  return {
    ...state,
    editRecord: {
      ...state.editRecord,
      errorMessage
    }
  };
};

const loadAttachmentForCourseRecordFinished = (state, { errorMessage }) => {
  return {
    ...state,
    editRecord: {
      ...state.editRecord,
      isSaving: false
    }
  };
};

const removeAttachment = (state, { attachment }) => {
  let record = state.newRecord.item;
  let remainingAttachements = record.attachmentFiles.filter(
    (item) => item.name !== attachment.name
  );
  record.attachmentFiles = remainingAttachements;
  return {
    ...state,
    newRecord: {
      ...state.newRecord,
      item: record
    }
  };
};

const removeAttachmentFromEditRecordMode = (state, { attachment }) => {
  let record = state.editRecord.item;
  let remainingAttachements = record.attachmentFiles.filter(
    (item) => item.name !== attachment.name
  );
  record.attachmentFiles = remainingAttachements;
  return {
    ...state,
    editRecord: {
      ...state.editRecord,
      item: record
    }
  };
};

//Handles the incoming actions.
export default handleActions(
  {
    [types.OPEN_CREATE_COURSE_DIALOG]: openCreateCourseDialog,
    [types.OPEN_EDIT_COURSE_PANEL]: openEditCoursePanel,
    [types.OPEN_EDIT_COURSE_DIALOG]: openEditCourseDialog,
    [types.INPUT_CHANGE_CREATE_COURSE_FORM]: inputChangeCreateCourseForm,

    [types.START_SUBMIT_COURSE]: startSubmitCourse,
    [types.SUBMIT_COURSE_SUCCESS]: submitCourseSuccess,
    [types.SUBMIT_COURSE_FAILURE]: submitCourseFailure,
    [types.SUBMIT_COURSE_FINISHED]: submitCourseFinished,

    [types.EDIT_COURSE]: editCourse,

    [types.START_SUBMIT_COURSE_RECORD]: startSubmitCourseRecord,
    [types.SUBMIT_COURSE_RECORD_SUCCESS]: submitCourseRecordSuccess,
    [types.SUBMIT_COURSE_RECORD_FAILURE]: submitCourseRecordFailure,
    [types.SUBMIT_COURSE_RECORD_FINISHED]: submitCourseRecordFinished,

    [types.START_FETCH_RECORDS_FOR_THE_COURSE]: startFetchRecordsForTheCourse,
    [types.FETCH_RECORDS_FOR_THE_COURSE_SUCCESS]: fetchRecordsForTheCourseSuccess,
    [types.FETCH_RECORDS_FOR_THE_COURSE_FAILURE]: fetchRecordsForTheCourseFailure,
    [types.FETCH_RECORDS_FOR_THE_COURSE_FINISHED]: fetchRecordsForTheCourseFinished,

    [types.START_DELETE_COURSE_RECORD]: startDeleteCourseRecord,
    [types.DELETE_COURSE_RECORD_SUCCESS]: deleteCourseRecordSuccess,
    [types.DELETE_COURSE_RECORD_FAILURE]: deleteCourseRecordFailure,
    [types.DELETE_COURSE_RECORD_FINISHED]: deleteCourseRecordFinished,

    [types.ENABLE_EDIT_COURSE_RECORD]: enableEditCourseRecord,

    [types.INPUT_CHANGE_EDIT_COURSE_RECORD]: inputChangeEditCourseRecord,
    [types.OPEN_ADD_COURSE_RECORD_DIALOG]: openAddCourseRecordDialog,

    [types.DOCUMENT_SELECTED]: courseDocumentSelected,

    //Course Record Attachement
    [types.START_LOAD_ATTACHMENTS_FOR_COURSE_RECORD]: startLoadAttachmentsForCourseRecord,
    [types.LOAD_ATTACHMENTS_FOR_COURSE_RECORD_SUCCESS]: loadAttachmentsForCourseRecordSuccess,
    [types.LOAD_ATTACHMENTS_FOR_COURSE_RECORD_FAILURE]: loadAttachmentForCourseRecordFailure,
    [types.LOAD_ATTACHMENTS_FOR_COURSE_RECORD_FINISHED]: loadAttachmentForCourseRecordFinished,

    [types.REMOVE_COURSE_RECORD_ATTACHMENT]: removeAttachment,

    [types.REMOVE_COURSE_RECORD_ATTACHMENT_EDIT]: removeAttachmentFromEditRecordMode
  },
  INITIAL_STATE
);
